import { RouterProvider } from "easy-page-router";

import { init } from "easy-analytics/client";

import Router from "./Router";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./components/Theme";
import { UserProvider } from "./components/User";
import { DialogProvider } from "./components/Dialog";

init(process.env.NODE_ENV === "development"
    ? "http://localhost:1111/api/easy-analytics"
    : "/api/easy-analytics");

export default function App() {
    return <ThemeProvider>
        <RouterProvider>
            <ErrorBoundary>
                <UserProvider>
                    <DialogProvider>
                        <Router />
                    </DialogProvider>
                </UserProvider>
            </ErrorBoundary>
        </RouterProvider>
    </ThemeProvider>;
}

// Fix iOS safari issus with viewport
if (global.window && global.document) { // only for browser
    const updateViewport = () => {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
            if (window.screen.width <= 600) {
                metaViewport.setAttribute('content', 'width=600, user-scalable=no');
            } else {
                metaViewport.setAttribute('content', 'width=device-width');
            }
        }
    }
    updateViewport();
    window.addEventListener('resize', updateViewport);
}
